import React from "react";
import "./AnalyticsConsentBanner.scss";

const AnalyticsConsentBanner = ({ consentPolicyUrl, onAccept, onReject }) => {
  return (
    <div className="web-analytics-consent" role="dialog" aria-label="Cookie consent">
      <div className="web-analytics-consent__inner">
        <p className="web-analytics-consent__text">
          Analytics cookies help the store owner see how the site is used. Accept
          or Reject — shopping is unchanged either way.
          {consentPolicyUrl ? (
            <>
              {" "}
              <a
                className="web-analytics-consent__link"
                href={consentPolicyUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                Learn more
              </a>
            </>
          ) : null}
        </p>
        <div className="web-analytics-consent__actions">
          <button
            type="button"
            className="web-analytics-consent__btn web-analytics-consent__btn--reject"
            onClick={onReject}
          >
            Reject
          </button>
          <button
            type="button"
            className="web-analytics-consent__btn web-analytics-consent__btn--accept"
            onClick={onAccept}
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
};

export default AnalyticsConsentBanner;
